import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { updatePassword } from "../../services/auth";
import { useLocale } from "../../stores/locale";
import { H2 } from "../h2";

export function PasswordForm() {
  const t = useLocale((state) => state.locale);
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [formError, setFormError] = useState(false);

  const [form, setForm] = useState({
    currentPassword: "",
    password: "",
    repeatPassword: "",
  });

  const isValid =
    form.password.trim().length >= 6 && form.password === form.repeatPassword;

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();
        (async () => {
          setIsLoading(true);
          try {
            await updatePassword(form.currentPassword, form.password);
            alert("Password updated!");
          } catch (error) {
            setFormError(true);
          } finally {
            setIsLoading(false);
          }
        })();
      }}
    >
      <H2>{t.profile.updatePassword}</H2>
      <div className="mt-5">
        <label htmlFor="currentPassword">{t.profile.currentPassword}</label>
        <InputText
          className="w-full"
          disabled={isLoading}
          id="currentPassword"
          invalid={formError}
          itemType="password"
          type="password"
          value={form.currentPassword}
          onChange={(event) =>
            setForm({ ...form, currentPassword: event.target.value })
          }
        />
        {formError && <small className="text-red-500" id="username-help" />}
      </div>
      <div className="mt-5">
        <label htmlFor="password">{t.profile.password}</label>
        <InputText
          className="w-full"
          disabled={isLoading}
          id="password"
          invalid={formError}
          itemType="password"
          type="password"
          value={form.password}
          onChange={(event) =>
            setForm({ ...form, password: event.target.value })
          }
        />
      </div>
      <div className="mt-5">
        <label htmlFor="repeatPassword">{t.profile.repeatPassword}</label>
        <InputText
          className="w-full"
          disabled={isLoading}
          id="repeatPassword"
          invalid={formError}
          itemType="password"
          type="password"
          value={form.repeatPassword}
          onChange={(event) =>
            setForm({ ...form, repeatPassword: event.target.value })
          }
        />
      </div>
      <div className="mt-5">
        <Button
          disabled={!isValid}
          label={t.profile.submit}
          severity="danger"
          type="submit"
        />
      </div>
    </form>
  );
}
